import React, { CSSProperties } from 'react';
import { observer } from 'mobx-react';


import { UiAvatar } from '../UiAvatar';

import './styles.scss';
import { UserModel } from 'shared/models';

type PropsType = {
    user: UserModel,
    style?: CSSProperties;
};
export const UiUserBadge = observer(function UiUserBadge({ style, user }: PropsType) {
    return (
        <div className='ui-new-user-badge' style={style}>
            <UiAvatar size={24} label={user.previewName} image={user.imageAvatar}/>
            <span>{user.previewName}</span>
        </div>
    );
});
